import dayjs from "dayjs"
import { useMemo, useState } from "react"

interface Value {
	month: number
	year: number
	setPrevious(): void
	setNext(): void
}
export default function useMonthNavigation(): Value {
	const [selectedDate, setSelectedDate] = useState(() => {
		const now = dayjs()
		return { month: now.month(), year: now.year() }
	})

	return useMemo<Value>(
		() => ({
			month: selectedDate.month,
			year: selectedDate.year,
			setPrevious() {
				setSelectedDate(prev =>
					prev.month > 0 ? { month: prev.month - 1, year: prev.year } : { month: 11, year: prev.year - 1 },
				)
			},
			setNext() {
				setSelectedDate(prev =>
					prev.month < 11 ? { month: prev.month + 1, year: prev.year } : { month: 0, year: prev.year + 1 },
				)
			},
		}),
		[selectedDate],
	)
}
